// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__container___eAyNI {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.style__circle___ElV_T {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    background-color: var(--primary-color);
    display: flex;
    justify-content: center;
    align-items: center;
}

.style__imageFile___e7Di6 {
    width: 40px;
    height: 40px;
    border-radius: 40px;
    object-fit: cover;
}

.style__name___adjoM {
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 1px;
}


.style__icon___YN2bt {
  width: 100%;
  height: 100%;
  background-image: linear-gradient(to right, var(--secondaryB-color), var(--secondaryA-color));
  color: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/components/ProfileMenu/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sCAAsC;IACtC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,6FAA6F;EAC7F,kBAAkB;AACpB","sourcesContent":[".container {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n}\n.circle {\n    width: 40px;\n    height: 40px;\n    border-radius: 20px;\n    background-color: var(--primary-color);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.imageFile {\n    width: 40px;\n    height: 40px;\n    border-radius: 40px;\n    object-fit: cover;\n}\n\n.name {\n    font-weight: bold;\n    font-size: 16px;\n    color: #FFFFFF;\n    letter-spacing: 1px;\n}\n\n\n.icon {\n  width: 100%;\n  height: 100%;\n  background-image: linear-gradient(to right, var(--secondaryB-color), var(--secondaryA-color));\n  color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style__container___eAyNI`,
	"circle": `style__circle___ElV_T`,
	"imageFile": `style__imageFile___e7Di6`,
	"name": `style__name___adjoM`,
	"icon": `style__icon___YN2bt`
};
export default ___CSS_LOADER_EXPORT___;
